var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable valid-jsdoc */
import { SvgRenderer } from '@syncfusion/ej2-svg-base';
import { Property, ChildProperty, Complex, Collection, isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * Specifies the color information for the gradient in the linear gauge.
 */
export class ColorStop extends ChildProperty {
}
__decorate([
    Property('#000000')
], ColorStop.prototype, "color", void 0);
__decorate([
    Property(1)
], ColorStop.prototype, "opacity", void 0);
__decorate([
    Property('0%')
], ColorStop.prototype, "offset", void 0);
__decorate([
    Property('')
], ColorStop.prototype, "style", void 0);
/**
 * Specifies the position in percentage from which the radial gradient must be applied.
 */
export class GradientPosition extends ChildProperty {
}
__decorate([
    Property('0%')
], GradientPosition.prototype, "x", void 0);
__decorate([
    Property('0%')
], GradientPosition.prototype, "y", void 0);
/**
 * This specifies the properties of the linear gradient colors for the linear gauge.
 */
export class LinearGradient extends ChildProperty {
}
__decorate([
    Property('0%')
], LinearGradient.prototype, "startValue", void 0);
__decorate([
    Property('100%')
], LinearGradient.prototype, "endValue", void 0);
__decorate([
    Collection([{ color: '#000000', opacity: 1, offset: '0%', style: '' }], ColorStop)
], LinearGradient.prototype, "colorStop", void 0);
/**
 * This specifies the properties of the radial gradient colors for the linear gauge.
 */
export class RadialGradient extends ChildProperty {
}
__decorate([
    Property('0%')
], RadialGradient.prototype, "radius", void 0);
__decorate([
    Complex({ x: '0%', y: '0%' }, GradientPosition)
], RadialGradient.prototype, "outerPosition", void 0);
__decorate([
    Complex({ x: '0%', y: '0%' }, GradientPosition)
], RadialGradient.prototype, "innerPosition", void 0);
__decorate([
    Collection([{ color: '#000000', opacity: 1, offset: '0%', style: '' }], ColorStop)
], RadialGradient.prototype, "colorStop", void 0);
/**
 * To get the gradient support for pointers and ranges in the linear gauge.
 *
 * @hidden
 */
export class Gradient {
    constructor(control) {
        this.gauge = control;
    }
    /**
     * To get the linear gradient string.
     *
     * @private
     */
    getLinearGradientColor(element) {
        const render = new SvgRenderer('');
        const colorStop = element.linearGradient.colorStop;
        const colors = this.getGradientColor(colorStop);
        const name = '_' + this.gauge.svgObject.id + '_' + this.gauge.gradientCount + '_' + 'linearGradient';
        const gradientPosition = {
            id: name,
            x1: (element.linearGradient.startValue.indexOf('%') === -1 ?
                element.linearGradient.startValue :
                parseFloat(element.linearGradient.startValue).toString()) + '%',
            x2: (element.linearGradient.endValue.indexOf('%') === -1 ?
                element.linearGradient.endValue :
                parseFloat(element.linearGradient.endValue).toString()) + '%',
            y1: '0' + '%',
            y2: '0' + '%'
        };
        const def = render.drawGradient('linearGradient', gradientPosition, colors);
        this.gauge.svgObject.appendChild(def);
        return 'url(#' + name + ')';
    }
    /**
     * To get the radial gradient string.
     *
     * @private
     */
    getRadialGradientColor(element) {
        const render = new SvgRenderer('');
        const colorStop = element.radialGradient.colorStop;
        const colors = this.getGradientColor(colorStop);
        const name = '_' + this.gauge.svgObject.id + '_' + this.gauge.gradientCount + '_' + 'radialGradient';
        const gradientPosition = {
            id: name,
            r: !isNullOrUndefined(element.radialGradient.radius) ?
                (element.radialGradient.radius.indexOf('%') === -1 ?
                    element.radialGradient.radius :
                    parseFloat(element.radialGradient.radius).toString()) + '%' : '0%',
            cx: element.radialGradient.outerPosition == null ? '0%' : (element.radialGradient.outerPosition.x.indexOf('%') === -1 ?
                element.radialGradient.outerPosition.x :
                parseFloat(element.radialGradient.outerPosition.x).toString()) + '%',
            cy: element.radialGradient.outerPosition == null ? '0%' : (element.radialGradient.outerPosition.y.indexOf('%') === -1 ?
                element.radialGradient.outerPosition.y :
                parseFloat(element.radialGradient.outerPosition.y).toString()) + '%',
            fx: element.radialGradient.innerPosition == null ? '0%' : (element.radialGradient.innerPosition.x.indexOf('%') === -1 ?
                element.radialGradient.innerPosition.y :
                parseFloat(element.radialGradient.innerPosition.x).toString()) + '%',
            fy: element.radialGradient.innerPosition == null ? '0%' : (element.radialGradient.innerPosition.y.indexOf('%') === -1 ?
                element.radialGradient.innerPosition.y :
                parseFloat(element.radialGradient.innerPosition.y).toString()) + '%'
        };
        const def = render.drawGradient('radialGradient', gradientPosition, colors);
        this.gauge.svgObject.appendChild(def);
        return 'url(#' + name + ')';
    }
    /**
     * To get the color, offset, opacity and style.
     *
     * @private
     */
    getGradientColor(colorStop) {
        const colors = [];
        const length = !isNullOrUndefined(colorStop) ? colorStop.length : 0;
        for (let j = 0; j < length; j++) {
            const gradientColorStop = colorStop[j];
            const color = {
                color: gradientColorStop.color,
                colorStop: gradientColorStop.offset,
                opacity: gradientColorStop.opacity ? (gradientColorStop.opacity).toString() : '1',
                style: gradientColorStop.style
            };
            colors.push(color);
        }
        return colors;
    }
    /**
     * To get the gradient color string.
     *
     * @private
     */
    getGradientColorString(element) {
        let gradientColor;
        if ((element.linearGradient || element.radialGradient)) {
            if (element.linearGradient) {
                gradientColor = this.getLinearGradientColor(element);
            }
            else {
                gradientColor = this.getRadialGradientColor(element);
            }
            this.gauge.gradientCount += 1;
        }
        else {
            return null;
        }
        return gradientColor;
    }
    /**
     * Get module name.
     */
    getModuleName() {
        return 'Gradient';
    }
    /**
     * To destroy the gradient.
     *
     * @return {void}
     * @private
     */
    destroy() {
        this.gauge = null;
    }
}
